import {ReactElement, HTMLAttributes} from 'react'
interface iProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  children: ReactElement | ReactElement[];
  className?: string;
}
export default function TabPane(props: iProps) {

  return (
    <div className={props.className ? props.className : ''}>{props.children}</div>
  )
}
